import { useQuery } from '@tanstack/react-query';
import { DataExportSchemaConfig } from '../types';

export default function useDataExportSchemaConfigById(configId: string | null) {
  return useQuery<DataExportSchemaConfig>({
    queryKey: ['data-export-configs', configId],
    enabled: !!configId,
  });
}
